/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentDefaultGradingScaleSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ASSIGNMENT_DEFAULT_GRADING_SCALE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ parsers.exactly('percentage', 'points')),
    ],
]);
export class AssignmentDefaultGradingScaleSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentDefaultGradingScaleSettingParser.decode(input).map(res => new AssignmentDefaultGradingScaleSetting(res));
    }
    static unsafeDecode(input) {
        return AssignmentDefaultGradingScaleSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentDefaultGradingScaleSettingParser.encode(data);
    }
    static schema() {
        return AssignmentDefaultGradingScaleSettingParser.schema();
    }
}
